
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'ホーム' },
    { path: '/menu', label: 'メニュー' },
    { path: '/gallery', label: 'ギャラリー' },
    { path: '/access', label: 'アクセス' },
    { path: '/booking', label: '予約' },
  ];

  return (
    <header className="fixed top-0 w-full bg-white/95 backdrop-blur-sm border-b border-pink-100 z-50">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="https://static.readdy.ai/image/309636e017ffa099c243a25008216468/145878042654b6a2e78f33d09ee232c3.png" 
              alt="puluchu logo" 
              className="w-8 h-8"
            />
            <div className="text-2xl font-bold text-purple-600" style={{ fontFamily: 'Pacifico, serif' }}>
              puluchu
            </div>
          </Link>
          
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="w-8 h-8 flex items-center justify-center"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl text-gray-700`}></i>
          </button>
        </div>
        
        {isMenuOpen && (
          <nav className="mt-4 pb-4 border-t border-pink-100 pt-4">
            <div className="space-y-3">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block py-2 px-3 rounded-lg transition-colors ${
                    location.pathname === item.path
                      ? 'bg-pink-100 text-purple-600 font-medium'
                      : 'text-gray-700 hover:bg-pink-50'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
